import React from 'react';
import { formatPrice } from '../utils/pricingUtils';

/**
 * Displays an individual pricing plan card
 */
const PlanCard = ({
  plan,
  isSelected = false,
  isCurrentPlan = false,
  isCurrentActive = false,
  isTrialUsed = false,
  buttonText = 'Subscribe Now',
  onSelect = () => {},
  onPurchase = () => {},
  isButtonDisabled = false
}) => {
  return (
    <div 
      className={`pricing-card ${isSelected ? 'selected' : ''} ${plan.id === 'custom' ? 'popular' : ''} ${isCurrentPlan ? 'current' : ''} ${isTrialUsed ? 'trial-used' : ''}`}
      onClick={onSelect}
    >
      {plan.id === 'custom' && <div className="popular-badge">Click-for-Custom</div>}
      {isCurrentPlan && <div className="current-badge">Current Plan</div>}
      {isTrialUsed && plan.id === 'free' && <div className="trial-used-badge">Trial Used</div>}
      
      <div className="plan-name">{plan.name}</div>
      <div className="plan-description">{plan.description}</div>
      
      <div className="plan-price">
        {typeof plan.price === 'number' ? (
          <>
            <span className="price">{formatPrice(plan.price)}</span>
            <span className="period">/month</span>
          </>
        ) : (
          <span className="price">{plan.price || 'Contact Us'}</span>
        )}
      </div>
      
      <div className="features-section">
        <h3>What's included:</h3>
        <ul className="plan-features">
          {plan.features.map((feature, idx) => (
            <li key={idx} className="feature-item">
              <span className="feature-icon">✓</span>
              {feature}
            </li>
          ))}
        </ul>
      </div>
      
      <button 
        className={`plan-cta-button ${isButtonDisabled ? 'disabled' : ''}`}
        onClick={(e) => {
          e.stopPropagation();
          if (!isButtonDisabled) {
            onPurchase();
          }
        }}
        disabled={isButtonDisabled}
      >
        {buttonText}
      </button>
    </div>
  );
};

export default PlanCard; 